var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNodeScale(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 61.7C9.6 61.7 4.5 56.6 4.5 50.2C4.5 43.8 9.6 38.7 16 38.7C22.4 38.7 27.5 43.8 27.5 50.2C27.5 56.6 22.4 61.7 16 61.7ZM16 39.8C10.3 39.8 5.6 44.4 5.6 50.1C5.6 55.8 10.3 60.5 16 60.5C21.7 60.5 26.3 55.9 26.4 50.2C26.5 44.5 21.7 39.8 16 39.8Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 54.7C18.4853 54.7 20.5 52.6853 20.5 50.2C20.5 47.7147 18.4853 45.7 16 45.7C13.5147 45.7 11.5 47.7147 11.5 50.2C11.5 52.6853 13.5147 54.7 16 54.7Z",
    fill: "#626097"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 54.2C18.2091 54.2 20 52.4091 20 50.2C20 47.9909 18.2091 46.2 16 46.2C13.7909 46.2 12 47.9909 12 50.2C12 52.4091 13.7909 54.2 16 54.2Z",
    stroke: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.80298 11.7532L24.5717 27.5215",
    stroke: "#626097",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.309 28.7943L27.1173 30.0671L25.8444 25.2588L22.309 28.7943Z",
    fill: "#626097"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1525 26.1525L7.31335 10.3134",
    stroke: "#626097",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.57608 9.04056L4.76776 7.76777L6.04055 12.5761L9.57608 9.04056Z",
    fill: "#626097"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNodeScale);
export default __webpack_public_path__ + "static/media/NodeScale.f2d4bb6d4d346872a02b5dbff430948f.svg";
export { ForwardRef as ReactComponent };